// extracted by mini-css-extract-plugin
module.exports = {"richProgressBar":"style_richProgressBar__Nn7Qd","goalInfo":"style_goalInfo__1faVu"};